module.exports = __webpack_public_path__ + "assets/img/25_402.47e23b76.jpg";